module.exports = __webpack_public_path__ + "static/google-play-badge-c701b48ca94ef5c3bbdb11c272c27afc.png";